import _toConsumableArray from "/home/hyuto/Hyuto.github.io/v3-beta/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import _assertThisInitialized from "/home/hyuto/Hyuto.github.io/v3-beta/node_modules/@babel/runtime/helpers/esm/assertThisInitialized.js";
import _inherits from "/home/hyuto/Hyuto.github.io/v3-beta/node_modules/@babel/runtime/helpers/esm/inherits.js";
import _possibleConstructorReturn from "/home/hyuto/Hyuto.github.io/v3-beta/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn.js";
import _getPrototypeOf from "/home/hyuto/Hyuto.github.io/v3-beta/node_modules/@babel/runtime/helpers/esm/getPrototypeOf.js";
import _asyncToGenerator from "/home/hyuto/Hyuto.github.io/v3-beta/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _classCallCheck from "/home/hyuto/Hyuto.github.io/v3-beta/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/home/hyuto/Hyuto.github.io/v3-beta/node_modules/@babel/runtime/helpers/esm/createClass.js";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

import _regeneratorRuntime from "/home/hyuto/Hyuto.github.io/v3-beta/node_modules/@babel/runtime/regenerator/index.js";

/**
 * @license
 * Copyright 2018 Google LLC
 *
 * Use of this source code is governed by an MIT-style
 * license that can be found in the LICENSE file or at
 * https://opensource.org/licenses/MIT.
 * =============================================================================
 */

/* Original source: keras/callbacks.py */
import { add, div, keep, mul, nextFrame, tidy, util } from '@tensorflow/tfjs-core';
import { ValueError } from './errors';
import { resolveScalarsInLogs } from './logs';
import * as generic_utils from './utils/generic_utils';
/** Verbosity logging level when fitting a model. */

export var ModelLoggingVerbosity;

(function (ModelLoggingVerbosity) {
  ModelLoggingVerbosity[ModelLoggingVerbosity["SILENT"] = 0] = "SILENT";
  ModelLoggingVerbosity[ModelLoggingVerbosity["VERBOSE"] = 1] = "VERBOSE";
})(ModelLoggingVerbosity || (ModelLoggingVerbosity = {}));
/** How often to yield to the main thread when training (in ms). */


export var DEFAULT_YIELD_EVERY_MS = 125;
/**
 * Abstract base class used to build new callbacks.
 *
 * The `logs` dictionary that callback methods take as argument will contain
 * keys for quantities relevant to the current batch or epoch.
 *
 * Currently, the `.fit()` method of the `Sequential` model class
 * will include the following quantities in the `logs` that
 * it passes to its callbacks:
 *
 * onEpochEnd: Logs include `acc` and `loss`, and optionally include `valLoss`
 *   (if validation is enabled in `fit`), and `valAcc` (if validation and
 *   accuracy monitoring are enabled).
 * onBatchBegin: Logs include `size`, the number of samples in the current
 *   batch.
 * onBatchEnd: Logs include `loss`, and optionally `acc` (if accuracy monitoring
 *   is enabled).
 */

export var BaseCallback = /*#__PURE__*/function () {
  function BaseCallback() {
    _classCallCheck(this, BaseCallback);

    // TODO(michaelterry): This type is a best guess.
    this.validationData = null;
  }

  _createClass(BaseCallback, [{
    key: "setParams",
    value: function setParams(params) {
      this.params = params;
    }
  }, {
    key: "onEpochBegin",
    value: function () {
      var _onEpochBegin = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(epoch, logs) {
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      function onEpochBegin(_x, _x2) {
        return _onEpochBegin.apply(this, arguments);
      }

      return onEpochBegin;
    }()
  }, {
    key: "onEpochEnd",
    value: function () {
      var _onEpochEnd = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(epoch, logs) {
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }));

      function onEpochEnd(_x3, _x4) {
        return _onEpochEnd.apply(this, arguments);
      }

      return onEpochEnd;
    }()
  }, {
    key: "onBatchBegin",
    value: function () {
      var _onBatchBegin = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(batch, logs) {
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      }));

      function onBatchBegin(_x5, _x6) {
        return _onBatchBegin.apply(this, arguments);
      }

      return onBatchBegin;
    }()
  }, {
    key: "onBatchEnd",
    value: function () {
      var _onBatchEnd = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(batch, logs) {
        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4);
      }));

      function onBatchEnd(_x7, _x8) {
        return _onBatchEnd.apply(this, arguments);
      }

      return onBatchEnd;
    }()
  }, {
    key: "onTrainBegin",
    value: function () {
      var _onTrainBegin = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5(logs) {
        return _regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5);
      }));

      function onTrainBegin(_x9) {
        return _onTrainBegin.apply(this, arguments);
      }

      return onTrainBegin;
    }()
  }, {
    key: "onTrainEnd",
    value: function () {
      var _onTrainEnd = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee6(logs) {
        return _regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6);
      }));

      function onTrainEnd(_x10) {
        return _onTrainEnd.apply(this, arguments);
      }

      return onTrainEnd;
    }() // LayersModel needs to call Callback.setModel(), but cannot actually depend
    // on Callback because that creates a cyclic dependency.  Providing this no-op
    // method on BaseCallback breaks the cycle: this way LayersModel can depend on
    // BaseCallback but not on Callback.  The argument is typed as `Container`
    // (the superclass of LayersModel) to avoid recapitulating the cycle. Callback
    // overrides this method and enforces that the argument is really a
    // LayersModel.

  }, {
    key: "setModel",
    value: function setModel(model) {// Do nothing. Use Callback instead of BaseCallback to track the model.
    }
  }]);

  return BaseCallback;
}();
/**
 * Container abstracting a list of callbacks.
 */

export var CallbackList = /*#__PURE__*/function () {
  // TODO(cais): When the need arises, uncomment the following lines and
  // implement the queue for time values.
  // private deltaTBatch: number;
  // private deltaTsBatchBegin: Array<number>;
  // private deltaTsBatchEnd: Array<number>;

  /**
   * Constructor of CallbackList.
   * @param callbacks Array of `Callback` instances.
   * @param queueLength Queue length for keeping running statistics over
   *   callback execution time.
   */
  function CallbackList(callbacks) {
    var queueLength = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 10;

    _classCallCheck(this, CallbackList);

    // TODO(cais): Make use of queueLength when implementing the queue for time
    // values.
    if (callbacks == null) {
      callbacks = [];
    }

    this.callbacks = callbacks;
    this.queueLength = queueLength;
  }

  _createClass(CallbackList, [{
    key: "append",
    value: function append(callback) {
      this.callbacks.push(callback);
    }
  }, {
    key: "setParams",
    value: function setParams(params) {
      var _iterator = _createForOfIteratorHelper(this.callbacks),
          _step;

      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var callback = _step.value;
          callback.setParams(params);
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
    }
  }, {
    key: "setModel",
    value: function setModel(model) {
      var _iterator2 = _createForOfIteratorHelper(this.callbacks),
          _step2;

      try {
        for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
          var callback = _step2.value;
          callback.setModel(model);
        }
      } catch (err) {
        _iterator2.e(err);
      } finally {
        _iterator2.f();
      }
    }
    /**
     * Called at the start of an epoch.
     * @param epoch Index of epoch.
     * @param logs Dictionary of logs.
     */

  }, {
    key: "onEpochBegin",
    value: function () {
      var _onEpochBegin2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee7(epoch, logs) {
        var _iterator3, _step3, callback;

        return _regeneratorRuntime.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                if (logs == null) {
                  logs = {};
                }

                _iterator3 = _createForOfIteratorHelper(this.callbacks);
                _context7.prev = 2;

                _iterator3.s();

              case 4:
                if ((_step3 = _iterator3.n()).done) {
                  _context7.next = 10;
                  break;
                }

                callback = _step3.value;
                _context7.next = 8;
                return callback.onEpochBegin(epoch, logs);

              case 8:
                _context7.next = 4;
                break;

              case 10:
                _context7.next = 15;
                break;

              case 12:
                _context7.prev = 12;
                _context7.t0 = _context7["catch"](2);

                _iterator3.e(_context7.t0);

              case 15:
                _context7.prev = 15;

                _iterator3.f();

                return _context7.finish(15);

              case 18:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee7, this, [[2, 12, 15, 18]]);
      }));

      function onEpochBegin(_x11, _x12) {
        return _onEpochBegin2.apply(this, arguments);
      }

      return onEpochBegin;
    }()
    /**
     * Called at the end of an epoch.
     * @param epoch Index of epoch.
     * @param logs Dictionary of logs.
     */

  }, {
    key: "onEpochEnd",
    value: function () {
      var _onEpochEnd2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee8(epoch, logs) {
        var _iterator4, _step4, callback;

        return _regeneratorRuntime.wrap(function _callee8$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                if (logs == null) {
                  logs = {};
                }

                _iterator4 = _createForOfIteratorHelper(this.callbacks);
                _context8.prev = 2;

                _iterator4.s();

              case 4:
                if ((_step4 = _iterator4.n()).done) {
                  _context8.next = 10;
                  break;
                }

                callback = _step4.value;
                _context8.next = 8;
                return callback.onEpochEnd(epoch, logs);

              case 8:
                _context8.next = 4;
                break;

              case 10:
                _context8.next = 15;
                break;

              case 12:
                _context8.prev = 12;
                _context8.t0 = _context8["catch"](2);

                _iterator4.e(_context8.t0);

              case 15:
                _context8.prev = 15;

                _iterator4.f();

                return _context8.finish(15);

              case 18:
              case "end":
                return _context8.stop();
            }
          }
        }, _callee8, this, [[2, 12, 15, 18]]);
      }));

      function onEpochEnd(_x13, _x14) {
        return _onEpochEnd2.apply(this, arguments);
      }

      return onEpochEnd;
    }()
    /**
     * Called  right before processing a batch.
     * @param batch Index of batch within the current epoch.
     * @param logs Dictionary of logs.
     */

  }, {
    key: "onBatchBegin",
    value: function () {
      var _onBatchBegin2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee9(batch, logs) {
        var _iterator5, _step5, callback;

        return _regeneratorRuntime.wrap(function _callee9$(_context9) {
          while (1) {
            switch (_context9.prev = _context9.next) {
              case 0:
                if (logs == null) {
                  logs = {};
                }

                _iterator5 = _createForOfIteratorHelper(this.callbacks);
                _context9.prev = 2;

                _iterator5.s();

              case 4:
                if ((_step5 = _iterator5.n()).done) {
                  _context9.next = 10;
                  break;
                }

                callback = _step5.value;
                _context9.next = 8;
                return callback.onBatchBegin(batch, logs);

              case 8:
                _context9.next = 4;
                break;

              case 10:
                _context9.next = 15;
                break;

              case 12:
                _context9.prev = 12;
                _context9.t0 = _context9["catch"](2);

                _iterator5.e(_context9.t0);

              case 15:
                _context9.prev = 15;

                _iterator5.f();

                return _context9.finish(15);

              case 18:
              case "end":
                return _context9.stop();
            }
          }
        }, _callee9, this, [[2, 12, 15, 18]]);
      }));

      function onBatchBegin(_x15, _x16) {
        return _onBatchBegin2.apply(this, arguments);
      }

      return onBatchBegin;
    }()
    /**
     * Called at the end of a batch.
     * @param batch Index of batch within the current epoch.
     * @param logs Dictionary of logs.
     */

  }, {
    key: "onBatchEnd",
    value: function () {
      var _onBatchEnd2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee10(batch, logs) {
        var _iterator6, _step6, callback;

        return _regeneratorRuntime.wrap(function _callee10$(_context10) {
          while (1) {
            switch (_context10.prev = _context10.next) {
              case 0:
                if (logs == null) {
                  logs = {};
                }

                _iterator6 = _createForOfIteratorHelper(this.callbacks);
                _context10.prev = 2;

                _iterator6.s();

              case 4:
                if ((_step6 = _iterator6.n()).done) {
                  _context10.next = 10;
                  break;
                }

                callback = _step6.value;
                _context10.next = 8;
                return callback.onBatchEnd(batch, logs);

              case 8:
                _context10.next = 4;
                break;

              case 10:
                _context10.next = 15;
                break;

              case 12:
                _context10.prev = 12;
                _context10.t0 = _context10["catch"](2);

                _iterator6.e(_context10.t0);

              case 15:
                _context10.prev = 15;

                _iterator6.f();

                return _context10.finish(15);

              case 18:
              case "end":
                return _context10.stop();
            }
          }
        }, _callee10, this, [[2, 12, 15, 18]]);
      }));

      function onBatchEnd(_x17, _x18) {
        return _onBatchEnd2.apply(this, arguments);
      }

      return onBatchEnd;
    }()
    /**
     * Called at the beginning of training.
     * @param logs Dictionary of logs.
     */

  }, {
    key: "onTrainBegin",
    value: function () {
      var _onTrainBegin2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee11(logs) {
        var _iterator7, _step7, callback;

        return _regeneratorRuntime.wrap(function _callee11$(_context11) {
          while (1) {
            switch (_context11.prev = _context11.next) {
              case 0:
                if (logs == null) {
                  logs = {};
                }

                _iterator7 = _createForOfIteratorHelper(this.callbacks);
                _context11.prev = 2;

                _iterator7.s();

              case 4:
                if ((_step7 = _iterator7.n()).done) {
                  _context11.next = 10;
                  break;
                }

                callback = _step7.value;
                _context11.next = 8;
                return callback.onTrainBegin(logs);

              case 8:
                _context11.next = 4;
                break;

              case 10:
                _context11.next = 15;
                break;

              case 12:
                _context11.prev = 12;
                _context11.t0 = _context11["catch"](2);

                _iterator7.e(_context11.t0);

              case 15:
                _context11.prev = 15;

                _iterator7.f();

                return _context11.finish(15);

              case 18:
              case "end":
                return _context11.stop();
            }
          }
        }, _callee11, this, [[2, 12, 15, 18]]);
      }));

      function onTrainBegin(_x19) {
        return _onTrainBegin2.apply(this, arguments);
      }

      return onTrainBegin;
    }()
    /**
     * Called at the end of training.
     * @param logs Dictionary of logs.
     */

  }, {
    key: "onTrainEnd",
    value: function () {
      var _onTrainEnd2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee12(logs) {
        var _iterator8, _step8, callback;

        return _regeneratorRuntime.wrap(function _callee12$(_context12) {
          while (1) {
            switch (_context12.prev = _context12.next) {
              case 0:
                if (logs == null) {
                  logs = {};
                }

                _iterator8 = _createForOfIteratorHelper(this.callbacks);
                _context12.prev = 2;

                _iterator8.s();

              case 4:
                if ((_step8 = _iterator8.n()).done) {
                  _context12.next = 10;
                  break;
                }

                callback = _step8.value;
                _context12.next = 8;
                return callback.onTrainEnd(logs);

              case 8:
                _context12.next = 4;
                break;

              case 10:
                _context12.next = 15;
                break;

              case 12:
                _context12.prev = 12;
                _context12.t0 = _context12["catch"](2);

                _iterator8.e(_context12.t0);

              case 15:
                _context12.prev = 15;

                _iterator8.f();

                return _context12.finish(15);

              case 18:
              case "end":
                return _context12.stop();
            }
          }
        }, _callee12, this, [[2, 12, 15, 18]]);
      }));

      function onTrainEnd(_x20) {
        return _onTrainEnd2.apply(this, arguments);
      }

      return onTrainEnd;
    }()
  }]);

  return CallbackList;
}();
/**
 * Callback that accumulates epoch averages of metrics.
 *
 * This callback is automatically applied to every LayersModel.
 */

export var BaseLogger = /*#__PURE__*/function (_BaseCallback) {
  _inherits(BaseLogger, _BaseCallback);

  var _super = _createSuper(BaseLogger);

  function BaseLogger() {
    _classCallCheck(this, BaseLogger);

    return _super.call(this);
  }

  _createClass(BaseLogger, [{
    key: "onEpochBegin",
    value: function () {
      var _onEpochBegin3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee13(epoch) {
        return _regeneratorRuntime.wrap(function _callee13$(_context13) {
          while (1) {
            switch (_context13.prev = _context13.next) {
              case 0:
                this.seen = 0;
                this.totals = {};

              case 2:
              case "end":
                return _context13.stop();
            }
          }
        }, _callee13, this);
      }));

      function onEpochBegin(_x21) {
        return _onEpochBegin3.apply(this, arguments);
      }

      return onEpochBegin;
    }()
  }, {
    key: "onBatchEnd",
    value: function () {
      var _onBatchEnd3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee14(batch, logs) {
        var _this = this;

        var batchSize, _loop, key;

        return _regeneratorRuntime.wrap(function _callee14$(_context14) {
          while (1) {
            switch (_context14.prev = _context14.next) {
              case 0:
                if (logs == null) {
                  logs = {};
                }

                batchSize = logs['size'] == null ? 0 : logs['size'];
                this.seen += batchSize;

                _loop = function _loop(key) {
                  var value = logs[key];

                  if (typeof value === 'number') {
                    if (!_this.totals.hasOwnProperty(key)) {
                      _this.totals[key] = 0;
                    }

                    _this.totals[key] = _this.totals[key] + value * batchSize;
                  } else {
                    var oldTotalsToDispose;

                    if (key in _this.totals) {
                      oldTotalsToDispose = _this.totals[key];
                    } else {
                      _this.totals[key] = 0;
                    }

                    var total = tidy(function () {
                      return add(_this.totals[key], mul(value, batchSize));
                    });
                    _this.totals[key] = total;

                    if (oldTotalsToDispose != null) {
                      oldTotalsToDispose.dispose();
                    }
                  }
                };

                for (key in logs) {
                  _loop(key);
                }

              case 5:
              case "end":
                return _context14.stop();
            }
          }
        }, _callee14, this);
      }));

      function onBatchEnd(_x22, _x23) {
        return _onBatchEnd3.apply(this, arguments);
      }

      return onBatchEnd;
    }()
  }, {
    key: "onEpochEnd",
    value: function () {
      var _onEpochEnd3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee15(epoch, logs) {
        var _this2 = this;

        var _iterator9, _step9, _loop2, _ret;

        return _regeneratorRuntime.wrap(function _callee15$(_context15) {
          while (1) {
            switch (_context15.prev = _context15.next) {
              case 0:
                if (!(logs != null)) {
                  _context15.next = 19;
                  break;
                }

                _iterator9 = _createForOfIteratorHelper(this.params['metrics']);
                _context15.prev = 2;

                _loop2 = function _loop2() {
                  var key = _step9.value;

                  if (_this2.totals[key] == null) {
                    return "continue";
                  }

                  if (typeof _this2.totals[key] === 'number') {
                    logs[key] = _this2.totals[key] / _this2.seen;
                  } else {
                    tidy(function () {
                      var log = mul(div(1, _this2.seen), _this2.totals[key]);
                      logs[key] = log;

                      _this2.totals[key].dispose();

                      keep(logs[key]);
                    });
                  }
                };

                _iterator9.s();

              case 5:
                if ((_step9 = _iterator9.n()).done) {
                  _context15.next = 11;
                  break;
                }

                _ret = _loop2();

                if (!(_ret === "continue")) {
                  _context15.next = 9;
                  break;
                }

                return _context15.abrupt("continue", 9);

              case 9:
                _context15.next = 5;
                break;

              case 11:
                _context15.next = 16;
                break;

              case 13:
                _context15.prev = 13;
                _context15.t0 = _context15["catch"](2);

                _iterator9.e(_context15.t0);

              case 16:
                _context15.prev = 16;

                _iterator9.f();

                return _context15.finish(16);

              case 19:
              case "end":
                return _context15.stop();
            }
          }
        }, _callee15, this, [[2, 13, 16, 19]]);
      }));

      function onEpochEnd(_x24, _x25) {
        return _onEpochEnd3.apply(this, arguments);
      }

      return onEpochEnd;
    }()
  }]);

  return BaseLogger;
}(BaseCallback);
/**
 * Callback that records events into a `History` object. This callback is
 * automatically applied to every TF.js Layers model. The `History` object
 * gets returned by the `fit` method of models.
 */

export var History = /*#__PURE__*/function (_BaseCallback2) {
  _inherits(History, _BaseCallback2);

  var _super2 = _createSuper(History);

  function History() {
    _classCallCheck(this, History);

    return _super2.apply(this, arguments);
  }

  _createClass(History, [{
    key: "onTrainBegin",
    value: function () {
      var _onTrainBegin3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee16(logs) {
        return _regeneratorRuntime.wrap(function _callee16$(_context16) {
          while (1) {
            switch (_context16.prev = _context16.next) {
              case 0:
                this.epoch = [];
                this.history = {};

              case 2:
              case "end":
                return _context16.stop();
            }
          }
        }, _callee16, this);
      }));

      function onTrainBegin(_x26) {
        return _onTrainBegin3.apply(this, arguments);
      }

      return onTrainBegin;
    }()
  }, {
    key: "onEpochEnd",
    value: function () {
      var _onEpochEnd4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee17(epoch, logs) {
        var key;
        return _regeneratorRuntime.wrap(function _callee17$(_context17) {
          while (1) {
            switch (_context17.prev = _context17.next) {
              case 0:
                if (logs == null) {
                  logs = {};
                }

                this.epoch.push(epoch);

                for (key in logs) {
                  if (this.history[key] == null) {
                    this.history[key] = [];
                  }

                  this.history[key].push(logs[key]);
                }

              case 3:
              case "end":
                return _context17.stop();
            }
          }
        }, _callee17, this);
      }));

      function onEpochEnd(_x27, _x28) {
        return _onEpochEnd4.apply(this, arguments);
      }

      return onEpochEnd;
    }()
    /**
     * Await the values of all losses and metrics.
     */

  }, {
    key: "syncData",
    value: function () {
      var _syncData = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee18() {
        var promises, keys, indices, key, valueArray, i, valueScalar, values, n, tensorToDispose;
        return _regeneratorRuntime.wrap(function _callee18$(_context18) {
          while (1) {
            switch (_context18.prev = _context18.next) {
              case 0:
                promises = [];
                keys = [];
                indices = [];

                for (key in this.history) {
                  valueArray = this.history[key];

                  for (i = 0; i < valueArray.length; ++i) {
                    if (typeof valueArray[i] !== 'number') {
                      valueScalar = valueArray[i];
                      promises.push(valueScalar.data());
                      keys.push(key);
                      indices.push(i);
                    }
                  }
                }

                _context18.next = 6;
                return Promise.all(promises);

              case 6:
                values = _context18.sent;

                for (n = 0; n < values.length; ++n) {
                  tensorToDispose = this.history[keys[n]][indices[n]];
                  tensorToDispose.dispose();
                  this.history[keys[n]][indices[n]] = values[n][0];
                }

              case 8:
              case "end":
                return _context18.stop();
            }
          }
        }, _callee18, this);
      }));

      function syncData() {
        return _syncData.apply(this, arguments);
      }

      return syncData;
    }()
  }]);

  return History;
}(BaseCallback);
/**
 * Custom callback for training.
 */

export var CustomCallback = /*#__PURE__*/function (_BaseCallback3) {
  _inherits(CustomCallback, _BaseCallback3);

  var _super3 = _createSuper(CustomCallback);

  function CustomCallback(args, yieldEvery) {
    var _this3;

    _classCallCheck(this, CustomCallback);

    _this3 = _super3.call(this);
    _this3.currentEpoch = 0;
    _this3.nowFunc = args.nowFunc;
    _this3.nextFrameFunc = args.nextFrameFunc || nextFrame;
    _this3.yieldEvery = yieldEvery || 'auto';

    if (_this3.yieldEvery === 'auto') {
      _this3.yieldEvery = DEFAULT_YIELD_EVERY_MS;
    }

    if (_this3.yieldEvery === 'never' && args.onYield != null) {
      throw new Error('yieldEvery is `never` but you provided an `onYield` callback. ' + 'Either change `yieldEvery` or remove the callback');
    }

    if (util.isNumber(_this3.yieldEvery)) {
      // Decorate `maybeWait` so it will be called at most once every
      // `yieldEvery` ms.
      _this3.maybeWait = generic_utils.debounce(_this3.maybeWait.bind(_assertThisInitialized(_this3)), _this3.yieldEvery, _this3.nowFunc);
    }

    _this3.trainBegin = args.onTrainBegin;
    _this3.trainEnd = args.onTrainEnd;
    _this3.epochBegin = args.onEpochBegin;
    _this3.epochEnd = args.onEpochEnd;
    _this3.batchBegin = args.onBatchBegin;
    _this3.batchEnd = args.onBatchEnd;
    _this3.yield = args.onYield;
    return _this3;
  }

  _createClass(CustomCallback, [{
    key: "maybeWait",
    value: function () {
      var _maybeWait = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee19(epoch, batch, logs) {
        var ps;
        return _regeneratorRuntime.wrap(function _callee19$(_context19) {
          while (1) {
            switch (_context19.prev = _context19.next) {
              case 0:
                ps = [];

                if (!(this.yield != null)) {
                  _context19.next = 5;
                  break;
                }

                _context19.next = 4;
                return resolveScalarsInLogs(logs);

              case 4:
                ps.push(this.yield(epoch, batch, logs));

              case 5:
                ps.push(this.nextFrameFunc());
                _context19.next = 8;
                return Promise.all(ps);

              case 8:
              case "end":
                return _context19.stop();
            }
          }
        }, _callee19, this);
      }));

      function maybeWait(_x29, _x30, _x31) {
        return _maybeWait.apply(this, arguments);
      }

      return maybeWait;
    }()
  }, {
    key: "onEpochBegin",
    value: function () {
      var _onEpochBegin4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee20(epoch, logs) {
        return _regeneratorRuntime.wrap(function _callee20$(_context20) {
          while (1) {
            switch (_context20.prev = _context20.next) {
              case 0:
                this.currentEpoch = epoch;

                if (!(this.epochBegin != null)) {
                  _context20.next = 6;
                  break;
                }

                _context20.next = 4;
                return resolveScalarsInLogs(logs);

              case 4:
                _context20.next = 6;
                return this.epochBegin(epoch, logs);

              case 6:
              case "end":
                return _context20.stop();
            }
          }
        }, _callee20, this);
      }));

      function onEpochBegin(_x32, _x33) {
        return _onEpochBegin4.apply(this, arguments);
      }

      return onEpochBegin;
    }()
  }, {
    key: "onEpochEnd",
    value: function () {
      var _onEpochEnd5 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee21(epoch, logs) {
        var ps;
        return _regeneratorRuntime.wrap(function _callee21$(_context21) {
          while (1) {
            switch (_context21.prev = _context21.next) {
              case 0:
                ps = [];

                if (!(this.epochEnd != null)) {
                  _context21.next = 5;
                  break;
                }

                _context21.next = 4;
                return resolveScalarsInLogs(logs);

              case 4:
                ps.push(this.epochEnd(epoch, logs));

              case 5:
                if (this.yieldEvery === 'epoch') {
                  ps.push(this.nextFrameFunc());
                }

                _context21.next = 8;
                return Promise.all(ps);

              case 8:
              case "end":
                return _context21.stop();
            }
          }
        }, _callee21, this);
      }));

      function onEpochEnd(_x34, _x35) {
        return _onEpochEnd5.apply(this, arguments);
      }

      return onEpochEnd;
    }()
  }, {
    key: "onBatchBegin",
    value: function () {
      var _onBatchBegin3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee22(batch, logs) {
        return _regeneratorRuntime.wrap(function _callee22$(_context22) {
          while (1) {
            switch (_context22.prev = _context22.next) {
              case 0:
                if (!(this.batchBegin != null)) {
                  _context22.next = 5;
                  break;
                }

                _context22.next = 3;
                return resolveScalarsInLogs(logs);

              case 3:
                _context22.next = 5;
                return this.batchBegin(batch, logs);

              case 5:
              case "end":
                return _context22.stop();
            }
          }
        }, _callee22, this);
      }));

      function onBatchBegin(_x36, _x37) {
        return _onBatchBegin3.apply(this, arguments);
      }

      return onBatchBegin;
    }()
  }, {
    key: "onBatchEnd",
    value: function () {
      var _onBatchEnd4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee23(batch, logs) {
        var ps;
        return _regeneratorRuntime.wrap(function _callee23$(_context23) {
          while (1) {
            switch (_context23.prev = _context23.next) {
              case 0:
                ps = [];

                if (!(this.batchEnd != null)) {
                  _context23.next = 5;
                  break;
                }

                _context23.next = 4;
                return resolveScalarsInLogs(logs);

              case 4:
                ps.push(this.batchEnd(batch, logs));

              case 5:
                if (this.yieldEvery === 'batch') {
                  ps.push(this.nextFrameFunc());
                } else if (util.isNumber(this.yieldEvery)) {
                  ps.push(this.maybeWait(this.currentEpoch, batch, logs));
                }

                _context23.next = 8;
                return Promise.all(ps);

              case 8:
              case "end":
                return _context23.stop();
            }
          }
        }, _callee23, this);
      }));

      function onBatchEnd(_x38, _x39) {
        return _onBatchEnd4.apply(this, arguments);
      }

      return onBatchEnd;
    }()
  }, {
    key: "onTrainBegin",
    value: function () {
      var _onTrainBegin4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee24(logs) {
        return _regeneratorRuntime.wrap(function _callee24$(_context24) {
          while (1) {
            switch (_context24.prev = _context24.next) {
              case 0:
                if (!(this.trainBegin != null)) {
                  _context24.next = 5;
                  break;
                }

                _context24.next = 3;
                return resolveScalarsInLogs(logs);

              case 3:
                _context24.next = 5;
                return this.trainBegin(logs);

              case 5:
              case "end":
                return _context24.stop();
            }
          }
        }, _callee24, this);
      }));

      function onTrainBegin(_x40) {
        return _onTrainBegin4.apply(this, arguments);
      }

      return onTrainBegin;
    }()
  }, {
    key: "onTrainEnd",
    value: function () {
      var _onTrainEnd3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee25(logs) {
        return _regeneratorRuntime.wrap(function _callee25$(_context25) {
          while (1) {
            switch (_context25.prev = _context25.next) {
              case 0:
                if (!(this.trainEnd != null)) {
                  _context25.next = 5;
                  break;
                }

                _context25.next = 3;
                return resolveScalarsInLogs(logs);

              case 3:
                _context25.next = 5;
                return this.trainEnd(logs);

              case 5:
              case "end":
                return _context25.stop();
            }
          }
        }, _callee25, this);
      }));

      function onTrainEnd(_x41) {
        return _onTrainEnd3.apply(this, arguments);
      }

      return onTrainEnd;
    }()
  }]);

  return CustomCallback;
}(BaseCallback);
/**
 * Standardize callbacks or configurations of them to an Array of callbacks.
 */

export function standardizeCallbacks(callbacks, yieldEvery) {
  if (callbacks == null) {
    callbacks = {};
  }

  if (callbacks instanceof BaseCallback) {
    return [callbacks];
  }

  if (Array.isArray(callbacks) && callbacks[0] instanceof BaseCallback) {
    return callbacks;
  } // Convert custom callback configs to custom callback objects.


  var callbackConfigs = generic_utils.toList(callbacks);
  return callbackConfigs.map(function (callbackConfig) {
    return new CustomCallback(callbackConfig, yieldEvery);
  });
}
/**
 * A global registry for callback constructors to be used during
 * LayersModel.fit().
 */

export var CallbackConstructorRegistry = /*#__PURE__*/function () {
  /**
   * Blocks public access to constructor.
   */
  function CallbackConstructorRegistry() {
    _classCallCheck(this, CallbackConstructorRegistry);
  }
  /**
   * Register a tf.LayersModel.fit() callback constructor.
   *
   * The registered callback constructor will be used to instantiate
   * callbacks for every tf.LayersModel.fit() call afterwards.
   *
   * @param verbosityLevel Level of verbosity at which the `callbackConstructor`
   *   is to be reigstered.
   * @param callbackConstructor A no-arg constructor for `tf.Callback`.
   * @throws Error, if the same callbackConstructor has been registered before,
   *   either at the same or a different `verbosityLevel`.
   */


  _createClass(CallbackConstructorRegistry, null, [{
    key: "registerCallbackConstructor",
    value: function registerCallbackConstructor(verbosityLevel, callbackConstructor) {
      util.assert(verbosityLevel >= 0 && Number.isInteger(verbosityLevel), function () {
        return "Verbosity level is expected to be an integer >= 0, " + "but got ".concat(verbosityLevel);
      });
      CallbackConstructorRegistry.checkForDuplicate(callbackConstructor);

      if (CallbackConstructorRegistry.constructors[verbosityLevel] == null) {
        CallbackConstructorRegistry.constructors[verbosityLevel] = [];
      }

      CallbackConstructorRegistry.constructors[verbosityLevel].push(callbackConstructor);
    }
  }, {
    key: "checkForDuplicate",
    value: function checkForDuplicate(callbackConstructor) {
      for (var levelName in CallbackConstructorRegistry.constructors) {
        var constructors = CallbackConstructorRegistry.constructors[+levelName];
        constructors.forEach(function (ctor) {
          if (ctor === callbackConstructor) {
            throw new ValueError('Duplicate callback constructor.');
          }
        });
      }
    }
    /**
     * Clear all registered callback constructors.
     */

  }, {
    key: "clear",
    value: function clear() {
      CallbackConstructorRegistry.constructors = {};
    }
    /**
     * Create callbacks using the registered callback constructors.
     *
     * Given `verbosityLevel`, all constructors registered at that level or above
     * will be called and the instantiated callbacks will be used.
     *
     * @param verbosityLevel: Level of verbosity.
     */

  }, {
    key: "createCallbacks",
    value: function createCallbacks(verbosityLevel) {
      var constructors = [];

      for (var levelName in CallbackConstructorRegistry.constructors) {
        var level = +levelName;

        if (verbosityLevel >= level) {
          constructors.push.apply(constructors, _toConsumableArray(CallbackConstructorRegistry.constructors[level]));
        }
      }

      return constructors.map(function (ctor) {
        return new ctor();
      });
    }
  }]);

  return CallbackConstructorRegistry;
}();
CallbackConstructorRegistry.constructors = {};
export function configureCallbacks(callbacks, verbose, epochs, initialEpoch, numTrainSamples, stepsPerEpoch, batchSize, doValidation, callbackMetrics) {
  var history = new History();
  var actualCallbacks = [new BaseLogger()].concat(_toConsumableArray(CallbackConstructorRegistry.createCallbacks(verbose)));

  if (callbacks != null) {
    actualCallbacks.push.apply(actualCallbacks, _toConsumableArray(callbacks));
  }

  actualCallbacks.push(history);
  var callbackList = new CallbackList(actualCallbacks); // TODO(cais): Figure out when this LayersModel instance can have a
  // dynamically
  //   set property called 'callback_model' as in PyKeras.

  callbackList.setParams({
    epochs: epochs,
    initialEpoch: initialEpoch,
    samples: numTrainSamples,
    steps: stepsPerEpoch,
    batchSize: batchSize,
    verbose: verbose,
    doValidation: doValidation,
    metrics: callbackMetrics
  });
  return {
    callbackList: callbackList,
    history: history
  };
}